import * as React from 'react'
import { useAylaTimeout } from '~/components/shared/AylaTimeout'

export const useAiResponseStream = () => {
  const [aiResponse, setAiResponse] = React.useState('')
  const [targetJob, setTargetJob] = React.useState(null)
  const [aiStreamComplete, setAiStreamComplete] = React.useState(false)
  const [aiStreamEmpty, setAiStreamEmpty] = React.useState(false)
  const [aiStreamClosed, setAiStreamClosed] = React.useState(false)
  const [retryCount, setRetryCount] = React.useState(0)
  const { timedOut, resetTimeout } = useAylaTimeout({
    waiting: !!targetJob && !aiStreamClosed && !aiStreamEmpty,
    activity: aiResponse,
  })
  const aiFailed = timedOut || aiStreamEmpty

  React.useEffect(() => {
    if (!targetJob) return
    if (timedOut) return

    const eventURL = `/job-search/jobs/${targetJob.id}/create_ai_sse?format=json`
    const eventSource = new EventSource(eventURL)
    let received = false

    eventSource.addEventListener('message', (event) => {
      if (event.data != 'null') {
        received = true
        setAiResponse((r) => `${r}${event.data}`)
      }
    })

    eventSource.addEventListener('error', (event) => {
      if (event.eventPhase === EventSource.CLOSED) {
        eventSource.close()
        if (received) {
          setAiStreamClosed(true)
        } else {
          setAiStreamEmpty(true)
        }
      }
    })

    return () => {
      eventSource.close()
    }
  }, [targetJob, timedOut, retryCount])

  const retryStream = React.useCallback(() => {
    setAiResponse('')
    setAiStreamComplete(false)
    setAiStreamEmpty(false)
    setAiStreamClosed(false)
    resetTimeout()
    setRetryCount((c) => c + 1)
  }, [resetTimeout])

  return {
    aiResponse,
    setAiResponse,
    targetJob,
    setTargetJob,
    aiStreamComplete,
    setAiStreamComplete,
    aiFailed,
    retryStream,
  }
}
